import React, { Component } from 'react'
import logo from '../../SFImages/logo.png';
import SFlogo from '../../SFImages/SFLogo.png';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { Button, Card, CardHeader, CardContent, Grid, Container, Stack, Tabs, Tab, CircularProgress, Box, Alert, InputAdornment, IconButton } from '@mui/material';
import { AppProperties, AppSetting, handleLoginToken, Logout } from '../../../common/functions';
import { toast } from 'react-toastify';
import validate from 'validate.js';
import './style.css'
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { isMobile, isBrowser } from 'react-device-detect';

validate.validators.emailDomain = function (value, options, key, attributes) {
    if (value && value.indexOf('@') !== -1) {
        const [, domain] = value.split('@');
        const domains = options.domains || [];
        const whitelistedEmails = options.whitelistedEmails || [];

        console.debug("value", value, domains, options, whitelistedEmails)
        if (whitelistedEmails.includes(value.toLowerCase())) {
            return;
        }

        if (!domains.includes(domain.toLowerCase())) {
            return options.message || '^Please use a valid email address';
        }
    }
};

validate.validators.passwordComplexity = function (value, options, key, attributes) {
    const minLength = options.minLength || 8;
    const hasNumber = /\d/.test(value);
    const hasUpperCase = /[A-Z]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasSpecialChar = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(value);

    if (!value || value.length < minLength) {
        return "^Must be at least 8 characters long and should contain a number, an upper case alphabet, a lower case alphabet and a special character";
    }

    if (!hasNumber || !hasUpperCase || !hasLowerCase || !hasSpecialChar) {
        return "^Must be at least 8 characters long and should contain a number, an upper case alphabet, a lower case alphabet and a special character";
    }
};


class SFAuth extends Component {

    appProperties = AppProperties();
    appSetting = AppSetting();

    defaultMessage = {
        show: false,
        type: '', // error, warning, success
        msg: '' // real message
    }

    constructor(props) {
        super(props)
        console.debug("this.props", this.props);
        this.state = {
            tab: 'password',
            authType: 'login',
            loading: false,

            // Password Login states
            emailID: '',
            password: '',

            // One Time Code States
            code: '',
            haveCode: false,
            registeredCode: false,

            // Register states
            firstName: '',
            lastName: '',
            password1: '',
            password2: '',
            confirmationEmailID: '',
            passwordLoginFieldErrors: null,
            requestCodeFieldErrors: null,
            registerFieldErrors: null,

            // Message
            message: this.defaultMessage,
            showPassword: false,
            showPassword1: false,
            showPassword2: false,
            showMoreMobile: false,
        }
    }

    passwordLoginSchema = {
        emailID: {
            presence: {
                allowEmpty: false,
                message: '^Please enter email ID'
            },
            email: true,
            emailDomain: {
                message: '^Please use a valid ' + this.appProperties.mailDomain.split(";") + ' email address',
                domains: this.appProperties.mailDomain.split(";"),
                whitelistedEmails: [...this.props.whitelist],
            }
        },
        password: {
            presence: {
                allowEmpty: false,
                message: '^Please enter a password'
            },
        },
    }

    requestCodeSchema = {
        emailID: {
            presence: {
                allowEmpty: false,
                message: '^Please enter email ID'
            },
            email: true,
            emailDomain: {
                message: '^Please use a valid ' + this.appProperties.mailDomain.split(";") + ' email address',
                domains: this.appProperties.mailDomain.split(";"),
                whitelistedEmails: [...this.props.whitelist],
            }
        },
    }

    registerSchema = {
        emailID: {
            presence: {
                allowEmpty: false,
                message: '^Please enter email ID'
            },
            email: true,
            emailDomain: {
                message: '^Please use a valid ' + this.appProperties.mailDomain.split(";") + ' email address',
                domains: this.appProperties.mailDomain.split(";"),
                whitelistedEmails: [...this.props.whitelist],
            }
        },
        firstName: {
            presence: {
                allowEmpty: false,
                message: '^Please enter your first name'
            },
            length: { minimum: 1 }
        },
        lastName: {
            presence: {
                allowEmpty: false,
                message: '^Please enter your last name'
            },
            length: { minimum: 1 }
        },
        password1: {
            presence: {
                allowEmpty: false,
                message: '^Please enter a password'
            },
            passwordComplexity: {
                minLength: 8,
            }
        },
        password2: {
            presence: {
                allowEmpty: false,
                message: '^Please enter a password'
            },
            equality: {
                attribute: "password1",
                message: "^Password's do not match!",
            },
            passwordComplexity: {
                minLength: 8,
                message: 'Must be at least 8 characters long and should contain a number, an upper case alphabet, a lower case alphabet and a special character',
            }
        },
        confirmationEmailID: {
            presence: {
                allowEmpty: false,
                message: '^Please enter email ID'
            },
            email: true,
            equality: {
                attribute: "emailID",
                message: "^Emaild IDs does not match!",
            },
            emailDomain: {
                message: '^',
                domains: this.appProperties.mailDomain.split(";"),
                whitelistedEmails: [...this.props.whitelist],
            }
        },
    }

    componentDidMount() {
        const queryParams = new URLSearchParams(window.location.search);
        let token = queryParams.get('token')
        let ltiUserID = queryParams.get('ltiUserID')
        if (token && ltiUserID && token !== "" && ltiUserID !== "") {
            this.setState({
                loading: true,
            })
            const [encodedHeader, encodedPayload, signature] = token.split('.');
            let decodedPayload;
            try {
                decodedPayload = JSON.parse(atob(encodedPayload));
            } catch (error) {
                console.error(error)
                return
            }
            console.debug("decodedPayload>?>>", decodedPayload, this.appProperties.enableLogin, this.appProperties?.currentUserData)
            if (decodedPayload) {
                //logout existing user
                if (this.appProperties.enableLogin) {
                    window.localStorage.setItem(this.appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'token', '');
                    window.localStorage.setItem(this.appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'GivenName', '');
                    window.localStorage.setItem(this.appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'USER_NAME', '');
                    window.localStorage.setItem(this.appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'UnixEpoch', '');
                    window.localStorage.setItem(this.appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'emailid', '');
                    window.localStorage.setItem(this.appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'OSUID', '');
                    window.localStorage.setItem(this.appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'role', '');
                    window.localStorage.setItem('isLTIStudent', '');
                }
                let exisitingUser = this.appProperties?.currentUserData?.USER_NAME
                console.debug("exisitingUser>>>", exisitingUser)
                // if (exisitingUser && exisitingUser !== "" && decodedPayload?.USER_NAME && decodedPayload?.USER_NAME !== "" &&  exisitingUser !== decodedPayload?.USER_NAME) {
                window.localStorage.setItem("isLTIStudent", decodedPayload.isLTIStudent);
                this.appProperties.currentUserData.setUserDetails(decodedPayload, this.appProperties.loginType);

                // Remove the token once it's been used
                if (queryParams.has('token')) {
                    queryParams.delete('token');
                    const newSearch = queryParams.toString();
                    const newPath = `${window.location.pathname}?${newSearch}`;

                    const encodedPath = encodeURI(newPath);

                    console.debug("encodedPath", encodedPath)

                    window.history.replaceState(null, '', encodedPath);
                    window.location.reload();
                }
            }
        }
    }

    getWhiteListFromServer = () => {
        const response = this.props.apiService({
            method: 'get',
            url: '/whitelist',
        });
        response.then(res => {
            if (res.data.message !== null && res.data.message !== '') {
                reject(res.data.message);
            }
            else {
                let whitelist = res.data.data;
                this.setState({
                    whitelistedEmails: whitelist,
                })
            }
        })
    }

    handleTabChange = (_, val) => {
        this.setState({
            tab: val,
            message: this.defaultMessage,
            loading: false,
            // Password Login states
            emailID: '',
            password: '',

            // One Time Code States
            code: '',
            haveCode: false,
            registeredCode: false,

            // Register states
            firstName: '',
            lastName: '',
            password1: '',
            password2: '',
            confirmationEmailID: '',
            passwordLoginFieldErrors: null,
            requestCodeFieldErrors: null,
            registerFieldErrors: null,

            showPassword: false,
            showPassword1: false,
            showPassword2: false,
        })
    }

    passwordLoginValidation = (data) => {
        let schema = this.passwordLoginSchema;
        schema.emailID.emailDomain.whitelistedEmails = this.props.whitelist;
        let errors = validate(data, schema);

        this.setState({
            passwordLoginFieldErrors: errors
        })
        return errors === undefined;
    }

    handlePasswordLogin = () => {
        toast.dismiss();

        let payload = {
            emailID: this.state.emailID,
            password: this.state.password,
        }

        if (!this.passwordLoginValidation(payload)) {
            return
        }

        this.setState({
            loading: true,
            message: this.defaultMessage,
        })

        const response = this.props.apiService({
            method: 'post',
            url: '/login',
            data: payload
        });

        response.then(res => {
            console.debug("res.data", res.data)
            let type = '';
            let msg = '';
            if (res.data && res.data.status === 1 && res.data.message) {
                type = 'error';
                msg = 'Sorry we could not find a match for the entered Username and Password combination in our system.';
            } else {
                type = 'success';
                msg = "You'll be logged in shortly"
                this.appProperties.currentUserData.setUserDetails(res.data.data, this.appProperties.loginType);
                window.location.reload();
            }

            this.setState({
                message: {
                    show: true,
                    type,
                    msg,
                }
            })

        }).finally(() => {
            this.setState({
                loading: false,
            })
        })
    }

    requestCodeValidation = (data) => {
        let schema = this.requestCodeSchema;
        schema.emailID.emailDomain.whitelistedEmails = this.props.whitelist;
        let errors = validate(data, schema);
        console.debug("errors", errors)
        this.setState({
            requestCodeFieldErrors: errors
        })
        return errors === undefined;
    }

    handleRequestOneTimeCode = () => {
        toast.dismiss();

        let payload = {
            emailID: this.state.emailID,
        }
        if (!this.requestCodeValidation(payload)) {
            return
        }

        this.setState({
            loading: true,
            message: this.defaultMessage,
        })

        const response = this.props.apiService({
            method: 'post',
            skipErrorHandle: true,
            url: '/sendCode',
            data: payload
        });

        response.then(res => {
            console.debug("res.data", res.data)
            let type = '';
            let msg = '';
            if (res.data && res.data.status === 1 && res.data.message) {
                type = 'error';
                msg = 'We could not find this user in our system. Please check your email or register this user';
            } else {
                type = 'success';
                msg = 'A 6-digit code should be sent to your email address. Please check in spam and quarantine folders too.'
                this.setState({
                    haveCode: true,
                    registeredCode: false
                })
            }
            this.setState({
                message: {
                    show: true,
                    type,
                    msg,
                }
            })
        }).finally(() => {
            this.setState({
                loading: false,
            })
        })
    }

    codeLoginValidation = (data) => {
        let codeLoginSchema = {
            ...this.requestCodeSchema,
            code: {
                presence: {
                    allowEmpty: false,
                    message: '^Please enter the code'
                },
                length: { is: 6, message: '^Please enter a valid code (should be 6 characters)' }
            }
        }

        let schema = codeLoginSchema;
        schema.emailID.emailDomain.whitelistedEmails = this.props.whitelist;
        let errors = validate(data, schema);

        console.debug("errors", errors)
        this.setState({
            requestCodeFieldErrors: errors
        })
        return errors === undefined;
    }

    handleCodeLogin = () => {

        let payload = {
            emailID: this.state.emailID,
            code: this.state.code,
        }

        this.setState({
            message: this.defaultMessage,
        })

        if (!this.codeLoginValidation(payload)) {
            return
        }

        this.setState({
            loading: true,
        })

        const response = this.props.apiService({
            method: 'post',
            skipErrorHandle: true,
            url: '/verifyCode',
            data: {
                ...payload,
                type: 'activation-code'
            }
        });

        response.then(res => {
            console.debug("res.data", res.data)
            let type = '';
            let msg = '';
            if (res.data && res.data.status === 1 && res.data.message) {
                type = 'error';
                msg = res.data.message;
            } else {
                this.setState({
                    authType: 'login',
                    haveCode: true,
                    tab: 'code',
                })
                type = 'success'
                msg = "You'll be logged in shortly";
                handleLoginToken(res.data.data);
            }
            this.setState({
                message: {
                    show: true,
                    type,
                    msg,
                }
            })
        }).finally(() => {
            this.setState({
                loading: false,
            })
        })
    }

    registerValidation = (data) => {

        let schema = this.registerSchema;
        schema.emailID.emailDomain.whitelistedEmails = this.props.whitelist;
        schema.confirmationEmailID.emailDomain.whitelistedEmails = this.props.whitelist;
        let errors = validate(data, schema);

        console.debug("errors", errors)
        this.setState({
            registerFieldErrors: errors
        })
        return errors === undefined;
    }

    handleRegister = () => {

        let data = {
            emailID: this.state.emailID,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            password1: this.state.password1,
            password2: this.state.password2,
            confirmationEmailID: this.state.confirmationEmailID,
        }

        if (!this.registerValidation(data)) {
            return
        }

        this.setState({
            loading: true,
            errorMessage: '',
            successMessage: '',
            message: {
                show: false,
                type: "",
                msg: "",
            }
        })

        let payload = {
            emailID: data.emailID,
            firstName: data.firstName,
            lastName: data.lastName,
            password: data.password1,
            userName: data.emailID.substring(0, data.emailID.indexOf("@"))
        }
        console.debug("payload", payload)
        const response = this.props.apiService({
            method: 'post',
            skipErrorHandle: false,
            url: '/registerUser',
            data: payload,
        });

        response.then(res => {
            console.debug("res.data", res.data)
            let type = '';
            let msg = '';
            if (res.data && res.data.status === 1 && res.data.message) {
                type = 'error';
                if (res.data.message === 'DUPLICATE REGISTRATION') {
                    msg = "Duplicate Registration detected, please request your instructor to activate your account. If you forgot your password, please login with one time code and update your password in your profile page";
                } else if (res.data.message === "Mail Send Error") {
                    msg = `Oops! We've encountered a error at our end.\nPlease report this issue to esbugs@ontoborn.com`;
                }
            } else {
                this.setState({
                    authType: 'login',
                    haveCode: true,
                    tab: 'code',
                    registeredCode: true
                });
                type = 'success';
                msg = 'Registration Successful. Please check your email (Spam/Quarantine folder too) to activate and login using your 6 digit code.'
            }
            this.setState({
                message: {
                    show: true,
                    type,
                    msg,
                }
            })
        }).finally(() => {
            this.setState({
                loading: false,
            })
        })
    }

    render() {

        const { tab, passwordLoginFieldErrors, requestCodeFieldErrors, registerFieldErrors, showPassword, showPassword1, showPassword2 } = this.state;

        return (
            <Container fullWidth className='h-100 position-relative'>
                <Grid container justifyContent={'center'} alignItems={'center'} height={'100%'} gap={isMobile ? 0 : 5}>
                    <Grid item lg={5} md={5} sm={12}>
                        <Stack spacing={2}>
                            <div className='w-100 text-align-center'>
                                <img src={SFlogo} width={300} alt="Stemfluecny Logo" />
                            </div>
                            {
                                isMobile ?

                                    <div className='d-flex justifyContent-center flex-column text-align-center'>
                                        <Typography className='d-inline' paddingRight={1} fontSize={20} color={'primary'} fontWeight={'500'}>
                                            Welcome.
                                        </Typography>
                                        <Typography className='d-inline mt-2' fontSize={20} fontWeight={500} lineHeight={"24px"}>
                                            Elevate Your STEM Journey!
                                        </Typography>
                                    </div>
                                    :

                                    <div>
                                        <Typography className='d-inline' paddingRight={1} fontSize={20} color={'primary'} fontWeight={'500'}>
                                            Welcome.
                                        </Typography>
                                        <Typography className='d-inline' fontSize={20} fontWeight={500} lineHeight={"24px"}>
                                            Elevate Your STEM Journey!
                                        </Typography>
                                    </div>

                            }
                            {
                                isMobile ?
                                    <div class="sfMobLogin-content-wrapper">
                                        <input onChange={() => this.setState({
                                            showMoreMobile: !this.state.showMoreMobile
                                        })} type="checkbox" id="sfMobLogin-toggle-content" class="sfMobLogin-toggle-input" />
                                        <div class="sfMobLogin-content">
                                            <Typography fontSize={14} lineHeight={"24px"} fontWeight={'300'} >
                                                Welcome to  {" "}
                                                <Typography className='d-inline' fontWeight={500}>
                                                    STEM Fluency
                                                </Typography>
                                                , your gateway to mastering essential STEM Skills! This application is tailored to elevate your understanding of fundamental concepts, preparing you for success in university-level physics courses. Dive into interactive modules, assessments, and engaging content designed to enhance your fluency in STEM. Empower your academic journey and unlock your potential with STEM Fluency — where knowledge meets proficiency.
                                            </Typography>
                                        </div>
                                        <div size={'small'} className='ml-10' width={"89px"} height={"20px"} variant='outlined'>

                                            <label for="sfMobLogin-toggle-content" class="sfMobLogin-toggle-label">
                                                <Typography className='d-inline' paddingRight={1} fontSize={10} color={'primary'} fontWeight={'700'} style={{ border: "2px solid rgba(187, 0, 0, 1)", borderRadius: "10px", padding: "2px 10px" }}>

                                                    {
                                                        this.state.showMoreMobile ?
                                                            "Less About SF" : "More About SF"
                                                    }

                                                </Typography>
                                            </label>
                                        </div>
                                    </div>
                                    :

                                    <div>

                                        <Typography fontSize={14} lineHeight={"24px"} fontWeight={'300'} className={isMobile ? "mx-4" : ""}>
                                            Welcome to STEM Fluency, your gateway to mastering essential STEM Skills! This application is tailored to elevate your understanding of fundamental concepts, preparing you for success in university-level physics courses. Dive into interactive modules, assessments, and engaging content designed to enhance your fluency in STEM. Empower your academic journey and unlock your potential with STEM Fluency — where knowledge meets proficiency.
                                        </Typography>
                                        <div className='d-flex flex-wrap mt-4'>
                                            <Button sx={{ width: 1 / 4, height: "35px" }} variant='contained' color='primary' onClick={() => {
                                                this.setState({ authType: 'register', message: this.defaultMessage, registerFieldErrors: null, })
                                            }}>Register</Button>
                                            <a className='d-inline-block' href={`${this.appProperties.appURL.replace("student", "cpanel")}`}>
                                                <Button size={isMobile ? 'small' : 'medium'} className='ml-4' color={'primary'} variant='text' fontWeight={500} fontSize={14}>
                                                    <span className='pr-2'>Not a Student?</span>
                                                    <span className='font-weight-bold' style={{ textDecoration: "underline", "text-underline-offset": "3px" }}>Register as Educator </span>
                                                    <span className='font-weight-bold' style={{ marginLeft: "3px", marginTop: "3px" }}>{" >> "}</span>
                                                </Button>
                                            </a>
                                        </div>
                                    </div>
                            }
                        </Stack>

                    </Grid>
                    <Grid item lg={6} md={6} sm={12} align={'center'} className={isMobile ? "pb-4 " : ""}>

                        {this.state.authType === 'login' &&
                            <Card sx={{ maxWidth: 438, minHeight: 470, boxShadow: ' 0px 4px 20px rgba(187, 0, 0, 0.25)', borderRadius: 4 }} className={isMobile ? 'py-1 position-relative' : 'px-4 py-2 position-relative'}>
                                <CardHeader title={
                                    <Typography align='center' fullWidth paddingRight={1} fontSize={32} color={'#bb0000'} fontWeight={'500'}>
                                        Student Login
                                    </Typography>
                                } />
                                {!(this.state.registeredCode && this.state.emailID) ?
                                    <Tabs sx={{ borderBottom: 1, borderColor: 'divider' }} value={tab} onChange={this.handleTabChange} variant="fullWidth" className='mx-4 mb-2' >
                                        <Tab label={<span className='fontClass-16 text-capitalize font-weight-bold text-nowrap'>Using Password</span>} value={'password'} />
                                        <Tab label={<span className='fontClass-16 text-capitalize font-weight-bold text-nowrap'>One Time Code</span>} value={'code'} />
                                    </Tabs>
                                    : ''}
                                <CardContent style={{ paddingBottom: '0px' }}>
                                    {tab === 'password' ?
                                        <div>
                                            <TextField
                                                value={this.state.emailID}
                                                onChange={event => {
                                                    this.setState({
                                                        emailID: event.target.value,
                                                    })
                                                }}
                                                error={(passwordLoginFieldErrors && passwordLoginFieldErrors['emailID']) ? true : false} label="Email"
                                                id="email"
                                                type='email'
                                                autoFocus
                                                fullWidth
                                                required
                                                className='mb-4'
                                                helperText={passwordLoginFieldErrors && passwordLoginFieldErrors['emailID'] ? passwordLoginFieldErrors['emailID'][0] : ''}
                                            />
                                            <TextField
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label="toggle password visibility"
                                                                onClick={() => this.setState({ showPassword: !showPassword })}
                                                            >
                                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    )
                                                }}
                                                value={this.state.password}
                                                onChange={event => {
                                                    this.setState({
                                                        password: event.target.value,
                                                    })
                                                }}
                                                error={(passwordLoginFieldErrors && passwordLoginFieldErrors['password']) ? true : false} label="Password"
                                                type={showPassword ? 'text' : 'password'}
                                                id="password"
                                                autoComplete={'off'}
                                                fullWidth
                                                required
                                                className={isMobile ? 'mb-1' : 'mb-4'}
                                                helperText={passwordLoginFieldErrors && passwordLoginFieldErrors['password'] ? passwordLoginFieldErrors['password'][0] : ''}
                                            />
                                            {isMobile ?

                                                <div className='d-flex justify-content-end mb-2'>
                                                    <Button onClick={() => {
                                                        this.setState({ tab: 'code' })
                                                    }} color={'primary'} variant='text' fontWeight={500} fontSize={11} style={{ textDecoration: "underline", "text-underline-offset": "3px" }}>Forgot password?</Button>



                                                </div>
                                                : ""
                                            }

                                            <Button
                                                className='loadingButton mt-1' variant='contained' color='primary' fullWidth
                                                disabled={this.state.loading}
                                                sx={{
                                                    '&:disabled': {
                                                        backgroundColor: '#bb0000',
                                                        color: 'white',
                                                    },
                                                }}
                                                onClick={this.handlePasswordLogin}
                                            >
                                                {this.state.loading ? <CircularProgress className='text-white' size={24} /> : 'Login'}
                                            </Button>
                                            {isMobile ?
                                                <Button
                                                    className='loadingButton mt-4' variant='outlined' color='primary' fullWidth
                                                    disabled={this.state.loading}
                                                    sx={{
                                                        '&:disabled': {
                                                            backgroundColor: '#bb0000',
                                                            color: 'white',
                                                        },
                                                    }}
                                                    onClick={() => {
                                                        this.setState({ authType: 'register', message: this.defaultMessage, registerFieldErrors: null, })
                                                    }}
                                                >
                                                    {this.state.loading && this.state.authType === "register" ? <CircularProgress className='text-white' size={24} /> : 'Register'}
                                                </Button>
                                                : ""}
                                            <Alert
                                                hidden={!this.state.message.show}
                                                severity={this.state.message.type}
                                                color={this.state.message.type}
                                                fontWeight={500}
                                                fontSize={14}
                                                className='mt-4 text-align-left'>
                                                {this.state.message.msg}
                                            </Alert>
                                            <div className={`d-flex justify-content-between w-100 mt-4`}>
                                                {!isMobile ?

                                                    <div>
                                                        <Button onClick={() => {
                                                            this.setState({ tab: 'code' })
                                                        }} color={'primary'} variant='text' fontWeight={500} fontSize={14} style={{ textDecoration: "underline", "text-underline-offset": "3px" }}>Forgot password?</Button>
                                                    </div>
                                                    : ""
                                                }

                                                <div style={{ flex: isMobile ? "auto" : "" }} className='pb-3'>
                                                    <a className='d-inline-block' href={`${this.appProperties.appURL.replace("student", "cpanel")}`}>
                                                        <Button color={'primary'} variant='text' fontWeight={500} fontSize={14} style={{ textDecoration: "underline", "text-underline-offset": "3px" }}>Switch to Educators Website</Button>
                                                    </a>
                                                </div>

                                            </div>
                                        </div>
                                        : null}

                                    {tab === 'code' ?
                                        <div>
                                            <TextField
                                                value={this.state.emailID}
                                                onChange={event => {
                                                    this.setState({
                                                        emailID: event.target.value,
                                                    })
                                                }}
                                                error={(requestCodeFieldErrors && requestCodeFieldErrors['emailID']) ? true : false} label="Email"
                                                id="email"
                                                type='email'
                                                autoFocus
                                                fullWidth
                                                disabled={this.state.registeredCode && this.state.emailID}
                                                required
                                                className='mb-4'
                                                helperText={requestCodeFieldErrors && requestCodeFieldErrors['emailID'] ? requestCodeFieldErrors['emailID'][0] : ''}
                                            />
                                            <TextField
                                                hidden={!this.state.haveCode}
                                                value={this.state.code}
                                                onChange={event => {
                                                    this.setState({
                                                        code: event.target.value,
                                                    })
                                                }}
                                                error={(requestCodeFieldErrors && requestCodeFieldErrors['code']) ? true : false}
                                                label="Code"
                                                id="code"
                                                type='text'
                                                autoFocus
                                                fullWidth
                                                required
                                                className='mb-4'
                                                helperText={requestCodeFieldErrors && requestCodeFieldErrors['code'] ? requestCodeFieldErrors['code'][0] : ''}
                                            />
                                            {this.state.haveCode ?
                                                <Button
                                                    variant='contained'
                                                    color='primary'
                                                    fullWidth
                                                    onClick={this.handleCodeLogin}
                                                    disabled={this.state.loading}
                                                    sx={{
                                                        '&:disabled': {
                                                            backgroundColor: '#bb0000',
                                                            color: 'white',
                                                        },
                                                    }}
                                                >
                                                    {this.state.loading ? <CircularProgress className='text-white' size={24} /> : 'Login'}
                                                </Button>
                                                :
                                                <div>
                                                    <Button
                                                        variant='contained' color='primary' fullWidth
                                                        disabled={this.state.loading}
                                                        sx={{
                                                            '&:disabled': {
                                                                backgroundColor: '#bb0000',
                                                                color: 'white',
                                                            },
                                                        }}
                                                        onClick={this.handleRequestOneTimeCode}
                                                    >
                                                        {this.state.loading ? <CircularProgress className='text-white' size={24} /> : 'Request One Time Code'}
                                                    </Button>
                                                </div>
                                            }
                                            <Alert
                                                hidden={!this.state.message.show}
                                                severity={this.state.message.type}
                                                color={this.state.message.type}
                                                fontWeight={500}
                                                fontSize={14}
                                                className='mt-4 text-align-left'>
                                                {this.state.message.msg}
                                            </Alert>

                                            <Box className='mt-4' hidden={!this.state.haveCode}>
                                                <Typography>
                                                    Didn't get the code?
                                                </Typography>
                                                <Button
                                                    hidden={!this.state.haveCode}
                                                    variant="text"
                                                    className='underline mt-3 inline-block' onClick={() => {
                                                        this.setState({
                                                            haveCode: false,
                                                            registeredCode: false,
                                                            message: this.defaultMessage,
                                                            code: '',
                                                            requestCodeFieldErrors: null,
                                                        })
                                                    }}>Send again</Button>
                                            </Box>
                                            <Button hidden={this.state.haveCode} variant="text" className='underline mt-3' onClick={() => {
                                                this.setState({
                                                    haveCode: true,
                                                    message: this.defaultMessage,
                                                    code: '',
                                                    requestCodeFieldErrors: null,
                                                })
                                            }}>I already have the code</Button>
                                        </div>
                                        : null}

                                </CardContent>
                            </Card>}
                        {this.state.authType === 'register' &&
                            <Card sx={{ maxWidth: 438, boxShadow: ' 0px 4px 20px rgba(187, 0, 0, 0.25)', borderRadius: 4 }} className={isMobile ? 'py-1 position-relative' : 'px-4 py-2 position-relative'}>
                                <CardHeader title={
                                    <Typography align='center' fullWidth paddingRight={1} fontSize={32} color={'#bb0000'} fontWeight={'500'}>
                                        Student Registration
                                    </Typography>
                                } />

                                <CardContent>
                                    <TextField
                                        onChange={event => this.setState({ emailID: event.target.value })}
                                        id='emailID'
                                        label="Email"
                                        fullWidth
                                        autoFocus
                                        type='email'
                                        required
                                        className='mb-4'
                                        error={(registerFieldErrors && registerFieldErrors['emailID']) ? true : false}
                                        helperText={registerFieldErrors && registerFieldErrors['emailID'] ? registerFieldErrors['emailID'][0] : ''}
                                    />
                                    <TextField
                                        onChange={event => this.setState({ firstName: event.target.value })}
                                        id='firstName'
                                        label="First Name"
                                        fullWidth
                                        required
                                        className='mb-4'
                                        error={(registerFieldErrors && registerFieldErrors['firstName']) ? true : false}
                                        helperText={registerFieldErrors && registerFieldErrors['firstName'] ? registerFieldErrors['firstName'][0] : ''}
                                    />
                                    <TextField
                                        onChange={event => this.setState({ lastName: event.target.value })}
                                        id='lastName'
                                        label="Last Name"
                                        fullWidth
                                        required
                                        className='mb-4'
                                        error={(registerFieldErrors && registerFieldErrors['lastName']) ? true : false}
                                        helperText={registerFieldErrors && registerFieldErrors['lastName'] ? registerFieldErrors['lastName'][0] : ''}
                                    />
                                    <TextField
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={() => this.setState({ showPassword1: !showPassword1 })}
                                                    >
                                                        {showPassword1 ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                        onChange={event => this.setState({ password1: event.target.value })}
                                        id='password1'
                                        label="Password"
                                        type={showPassword1 ? 'text' : 'password'}
                                        fullWidth
                                        required
                                        className='mb-4'
                                        error={(registerFieldErrors && registerFieldErrors['password1']) ? true : false}
                                        helperText={registerFieldErrors && registerFieldErrors['password1'] ? registerFieldErrors['password1'][0] : ''}
                                    />
                                    <TextField
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={() => this.setState({ showPassword2: !showPassword2 })}
                                                    >
                                                        {showPassword2 ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                        onChange={event => this.setState({ password2: event.target.value })}
                                        id='password2'
                                        label="Confirm Password"
                                        type={showPassword2 ? 'text' : 'password'}
                                        fullWidth
                                        required
                                        className='mb-4'
                                        error={(registerFieldErrors && registerFieldErrors['password2']) ? true : false}
                                        helperText={registerFieldErrors && registerFieldErrors['password2'] ? registerFieldErrors['password2'][0] : ''}
                                    />

                                    <TextField
                                        onChange={event => this.setState({ confirmationEmailID: event.target.value })}
                                        id='confirmationEmailID'
                                        label="Confirm Email"
                                        fullWidth
                                        type='email'
                                        required
                                        error={(registerFieldErrors && registerFieldErrors['confirmationEmailID']) ? true : false}
                                        helperText={registerFieldErrors && registerFieldErrors['confirmationEmailID'] ? registerFieldErrors['confirmationEmailID'][0] : ''}
                                        className='mb-4'
                                    />

                                    <Button variant='contained' color='primary' onClick={this.handleRegister} fullWidth
                                        disabled={this.state.loading}
                                        sx={{
                                            '&:disabled': {
                                                backgroundColor: '#bb0000',
                                                color: 'white',
                                            },
                                        }}>
                                        {this.state.loading ? <CircularProgress className='text-white' size={24} /> : 'Register'}
                                    </Button>

                                    <Alert
                                        hidden={!this.state.message.show}
                                        severity={this.state.message.type}
                                        color={this.state.message.type}
                                        fontWeight={500}
                                        fontSize={14}
                                        className='mt-4 text-align-left'>
                                        {this.state.message.msg}
                                    </Alert>

                                    <div className='d-flex justify-content-between w-100 mt-4'>
                                        <div>

                                            <Button onClick={() => {
                                                this.setState({
                                                    authType: 'login', tab: "password",
                                                    emailID: '',
                                                    password: '',
                                                    code: '',
                                                    message: this.defaultMessage,
                                                    registerFieldErrors: null,
                                                    passwordLoginFieldErrors: null,
                                                    requestCodeFieldErrors: null,
                                                    showPassword: false,
                                                    showPassword1: false,
                                                    showPassword2: false,
                                                })
                                            }} color={'primary'} variant='text' fontWeight={500} fontSize={14}>I have an account</Button>
                                        </div>
                                    </div>
                                </CardContent>
                            </Card>}
                    </Grid>
                </Grid>

            </Container>
        )
    }
}


export default SFAuth;